import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("evt_"), S.String).pipe(S.brand("@open-revenue/schema/stripe/EventId"), S.annotations({
    identifier: "@open-revenue/schema/stripe/EventId",
    description: "The id of the event in Stripe",
    examples: [
        "evt_1234567890"
    ]
}));
export const make = (eventId)=>S.decodeUnknown(Schema)(eventId);
export const makeUnsafe = (eventId)=>eventId;
